import { Link } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { AlertTriangle } from "lucide-react";

export function DunningBanner() {
  const { subscriptionStatus, lang } = useAuth();
  const locale = lang === "es" ? "es" : "en";

  if (subscriptionStatus !== "dunning") {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] w-full bg-amber-50 text-amber-900 px-4 py-2 border-b border-amber-200">
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 max-w-7xl mx-auto text-sm">
        <AlertTriangle className="w-4 h-4 shrink-0 text-amber-600" aria-hidden />
        <span>
          {locale === "es"
            ? "Hubo un problema con el pago de tu suscripción."
            : "There was a problem with your subscription payment."}
        </span>
        <Link
          to="/account"
          className="underline underline-offset-2 hover:text-amber-800 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-1 rounded shrink-0"
        >
          {locale === "es"
            ? "Ir a la cuenta para solucionarlo"
            : "Go to your account to fix it"}
        </Link>
      </div>
    </div>
  );
}
